<div class="modal-header">
    <h4>{{localize(langSection.ExportModal, langText.ExportCommentsHeader)}}</h4>
    <button class="btn-close" (click)="close()"></button>
</div>
<div class="modal-body">
    <p>{{localize(langSection.ExportModal, langText.ExportCommentsBodyText)}}</p>
    <p>{{localize(langSection.ExportModal, langText.ExportCommentsBodyExplanation)}}</p>
    <div class="form-check">
        <input id="includeCommentsChkbx" type="checkbox" class="form-check-input" [(ngModel)]="includeComments">
        <label class="form-check-label" for="includeCommentsChkbx">{{localize(langSection.ExportModal,
            langText.ExportCommentsCheckLabel)}}</label>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-green" [disabled]="exporting" (click)="confirm()">{{localize(langSection.ExportModal, langText.Export)}}</button>
    @if (receivedError) {
<div class="text-danger">{{localize(langSection.ExportModal, langText.FailedToExport)}}</div>
}
</div>